<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'
import ServiceStatusDialog from '@/components/app/service-status-dialog.vue'

export default {
  name: 'ServiceStatusAlert',
  components: {
    ServiceStatusDialog,
  },
  mixins: [baseMixin],
  data: () => {
    return {
      status: null,
      showDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      serviceStatus: 'serviceStatus',
    }),
  },
  async created() {
    const result = await this.fetchServiceStatus()

    if (!result.isSuccess) return
    this.status = this.serviceStatus
  },
  methods: {
    ...mapActions({
      fetchServiceStatus: 'fetchServiceStatus',
    }),
  },
}
</script>

<template>
  <article v-if="status" class="w-100" style="z-index: 6;">
    <v-alert tile dark class="mb-0">
      <section class=" d-flex justify-space-between align-center">
        <header class="d-flex">
          <v-icon class="mr-4" left>mdi-broadcast</v-icon>
          <h4
            :class="isMobileViewPort ? 'body-2' : ''"
            title="Service status alert title"
          >
            {{ status.bannerTitle | truncateText(isMobileViewPort ? 60 : 0) }}
          </h4>
        </header>
        <div class="d-flex align-center">
          <v-btn
            outlined
            dark
            :small="isMobileViewPort"
            @click="showDialog = true"
          >
            Learn More
          </v-btn>
        </div>
      </section>
    </v-alert>
    <v-dialog
      v-model="showDialog"
      max-width="800"
      scrollable
      content-class="rounded-0"
      @input="showDialog = false"
    >
      <ServiceStatusDialog v-if="showDialog" @closeModal="showDialog = false" />
    </v-dialog>
  </article>
</template>
